import type { GridSize, Table } from '../types';

export interface GridLayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

export function isValidTableLayout(item: GridLayoutItem, tables: Table[], gridSize: GridSize): boolean {
  const { cols, rows } = gridSize;
  if (item.x < 0 || item.y < 0) return false;
  if (item.x + item.w > cols) return false;
  if (item.y + item.h > rows) return false;

  for (const other of tables) {
    if (other.id === item.i) continue;
    if (
      item.x < other.x + other.w &&
      item.x + item.w > other.x &&
      item.y < other.y + other.h &&
      item.y + item.h > other.y
    ) {
      return false;
    }
  }

  return true;
}

export function applyLayoutToTables(tables: Table[], layout: GridLayoutItem[]): Table[] {
  return tables.map(table => {
    const item = layout.find(entry => entry.i === table.id);
    return item ? { ...table, x: item.x, y: item.y, w: item.w, h: item.h } : table;
  });
}

export function revertTableLayout(tables: Table[], itemId: string, oldItem: GridLayoutItem): Table[] {
  return tables.map(table => (
    table.id === itemId
      ? { ...table, x: oldItem.x, y: oldItem.y, w: oldItem.w, h: oldItem.h }
      : table
  ));
}
